import { animate, animation, style } from '@angular/animations';

export const slideOutHorizontal = animation(
  [
    style({
      opacity: 1,
      transform: 'translateX(0)',
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      style({
        opacity: 0,
        transform: 'translateX({{ translateX }})',
      }),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      easing: 'ease-in',
      translateX: '10%', // can be any unit
    },
  },
);
